import library from './library'

export default (dataService, domain, libraryServicesApi) => {
    const { getOauthServerDomain } = library(domain, libraryServicesApi)

    return dataService.create({
        baseURL: getOauthServerDomain(),
    })
}
